import * as React from 'react';
import clsx from 'clsx';
import { Button } from '@/components/ui/Button';
import { PlusIcon } from '@heroicons/react/24/outline';

interface AddInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onAdd?: () => void;
}

/** Text input with an inline "Add" button for appending items to a list. */
export const AddInput: React.FC<AddInputProps> = ({ className, onAdd, ...props }) => (
  <div className='relative w-full'>
    <input
      type='text'
      className={clsx(
        'h-[54px] w-full',
        'rounded-10',
        'pl-4 pr-[100px]',
        'border border-gray-310 bg-white',
        'font-sans text-14 text-brand-800 placeholder:text-gray-450',
        'focus:border-brand-750 focus:outline-none focus:ring-0',
        className
      )}
      {...props}
    />

    <div className='absolute right-2 top-1/2 -translate-y-1/2'>
      <Button
        type='button'
        variant='purple-dark'
        className='h-[38px] gap-1 rounded-30 px-4 text-12 font-bold uppercase shadow-none'
        onClick={onAdd}
      >
        <PlusIcon className='size-4' strokeWidth={2.5} />
        Add
      </Button>
    </div>
  </div>
);
